import {
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Tooltip,
  CircularProgress,
  Chip,
  Grid,
  Divider,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import HistoryIcon from "@mui/icons-material/History";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DashboardHeader from "../../components/headers/DashboardHeader";
import CustomConfirmation from "../../components/customComponents/customCpnfirmations/CustomConfirmation";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import BlockIcon from "@mui/icons-material/Block";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { detail_user_form, list_addon_api } from "../../DAL/form/userForm";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WorkIcon from "@mui/icons-material/Work";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddonSummary from "./AddonSummary";
import FileManagement from "./FileManagement";
import StatusHistoryDialog from "../../components/dialogs/StatusHistoryDialog";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";

export const show_proper_words = (text) => {
  let replace_string = "";
  if (text) {
    replace_string = text.replace(/[-_]/g, " ");
    replace_string = replace_string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return replace_string;
};

let button_history_styles = {
  color: "#334155",
  border: "1px solid #e2e8f0",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
  "&:hover": {
    backgroundColor: "#f8fafc",
    borderColor: "#cbd5e1",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.08)",
  },
};

function DraftPage() {
  const [paymentMethod, setPaymentMethod] = useState("credit");
  const [selectedNote, setSelectedNote] = useState("");
  const [openBy, setOpenBy] = useState(false);

  const handleChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusDialogMode, setStatusDialogMode] = useState("history"); // "history" or "reason"

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const navigate = useNavigate();
  const handleDeleteOpen = () => {
    setLogoutDialogOpen(true);
  };

  const [initialLoading, setInitialLoading] = useState(true);
  const [findData, setFindData] = useState({});
  const [addonFormList, setAddonFormList] = useState([]);

  const handleFetchDetail = async () => {
    setInitialLoading(true);
    const result = await detail_user_form();
    if (result.code === 200) {
      setFindData(result?.form);
      setInitialLoading(false);
    } else {
      setInitialLoading(false);
    }
  };

  const handleLogout = () => {
    setLogoutDialogOpen(false);
  };

  const handleReasonDialogOpen = (record) => {
    if (record && record.createdAt) {
      setSelectedNote(record);
      setOpenBy(true);
    } else {
      setSelectedNote("");
      setOpenBy(false);
    }
    setStatusDialogMode("reason");
    setOpenStatusDialog(true);
  };

  const handleHistoryDialogOpen = () => {
    setStatusDialogMode("history");
    setOpenStatusDialog(true);
  };

  const handleStatusDialogClose = () => {
    setOpenStatusDialog(false);
    setSelectedNote("");
    setOpenBy(false);
  };

  const handleContinue = () => {
    if (!findData?.form || !Array.isArray(findData?.form)) {
      navigate(`/visa/getting_started`);
      return;
    }

    const formList = findData?.form;

    // Find next incomplete section or sub-section
    for (let i = 0; i < formList.length; i++) {
      const section = formList[i];

      // Skip dashboard
      if (section.value === "dashboard") continue;

      // If section is not completed
      if (!section.is_completed) {
        // If it has sub-sections, find first incomplete sub-section
        if (section.has_sub_sections && section.sub_sections?.length > 0) {
          const incompleteSubSection = section.sub_sections.find(
            (sub) => !sub.is_completed
          );
          if (incompleteSubSection) {
            navigate(`/visa/${section.value}/${incompleteSubSection.value}`);
            return;
          }
        }
        // Navigate to the incomplete section
        navigate(`/visa/${section.value}`);
        return;
      }

      // If section is completed but has incomplete sub-sections
      if (section.has_sub_sections && section.sub_sections?.length > 0) {
        const incompleteSubSection = section.sub_sections.find(
          (sub) => !sub.is_completed
        );
        if (incompleteSubSection) {
          navigate(`/visa/${section.value}/${incompleteSubSection.value}`);
          return;
        }
      }
    }

    // If all sections are completed, go to the last section
    const lastSection = formList[formList.length - 1];
    if (lastSection && lastSection.value !== "dashboard") {
      if (
        lastSection.has_sub_sections &&
        lastSection.sub_sections?.length > 0
      ) {
        const lastSubSection =
          lastSection.sub_sections[lastSection.sub_sections.length - 1];
        navigate(`/visa/${lastSection.value}/${lastSubSection.value}`);
      } else {
        navigate(`/visa/${lastSection.value}`);
      }
      return;
    }

    // Default fallback
    navigate(`/visa/getting_started`);
  };

  function getIcon(status, initialPaymentStatus, investmentPaymentStatus) {
    if (status === "rejected") {
      return (
        <HighlightOffIcon sx={{ color: "#15978a", fontSize: 20, mr: 1 }} />
      );
    }
    if (investmentPaymentStatus === "paid") {
      return <CheckCircleIcon sx={{ color: "#15978a", fontSize: 20, mr: 1 }} />;
    }
    if (
      status === "approved" &&
      initialPaymentStatus === "paid" &&
      investmentPaymentStatus !== "paid"
    ) {
      return <WorkIcon sx={{ color: "#15978a", fontSize: 20, mr: 1 }} />;
    }
    if (initialPaymentStatus === "paid" && status === "pending") {
      return <CheckCircleIcon sx={{ color: "#15978a", fontSize: 20, mr: 1 }} />;
    }
    return <InfoIcon sx={{ color: "#15978a", fontSize: 20, mr: 1 }} />;
  }

  function getQuestionStatement(
    status,
    initialPaymentStatus,
    investmentPaymentStatus
  ) {
    if (status === "rejected") {
      return {
        question_statement: `
      <span style="font-weight: 600;">Rejected:</span> Unfortunately, your application was not approved.
      <br />
      You may click the  <i class="fas fa-eye" style="color: #15978a;"></i>  icon below to view the reason for rejection. Please review the feedback, update your application, and resubmit for further consideration.
    `,
      };
    }

    if (status === "info_required") {
      return {
        question_statement: `
      <span style="font-weight: 600;">Information Required:</span> Your application is missing some information.
      <br />
      You may click the  <i class="fas fa-eye" style="color: #15978a;"></i>  icon below to view the details of the missing information. Please provide the necessary information and resubmit your application.
    `,
      };
    }

    // Investment Fee Paid
    if (investmentPaymentStatus === "paid") {
      return {
        question_statement: `
        <span style="font-weight: 600;">Investment Fee Status:</span> Your payment has been successfully received. Our team will now proceed with the final steps of your application.
      `,
      };
    }

    // Investment Fee Processing
    if (
      initialPaymentStatus === "paid" &&
      investmentPaymentStatus === "processing"
    ) {
      return {
        question_statement: `
        <span style="font-weight: 600;">Your investment payment is being processed.</span><br />
        Please wait for confirmation. You will be notified once the payment is complete.
      `,
      };
    }

    // Investment Fee Due
    if (
      status === "approved" &&
      initialPaymentStatus === "paid" &&
      investmentPaymentStatus !== "paid"
    ) {
      return {
        question_statement: `
        <span style="font-weight: 600;">Investment Fee Status:</span> Your application has been approved. Please proceed to pay the investment fee to continue with the next steps.
      `,
      };
    }

    // Processing Fee Paid (when investment not yet paid and still pending)
    if (initialPaymentStatus === "paid" && status === "pending") {
      return {
        question_statement: `
        <span style="font-weight: 600;">Processing Fee Status:</span> Your payment has been successfully processed and recorded.
      `,
      };
    }

    // Processing Fee Paid (general fallback)
    if (initialPaymentStatus === "paid") {
      return {
        question_statement: `
        You have successfully passed the background check and are now formally approved to continue in the Little Haiti in Host Country program. To finalize your enrollment, please submit the investment payment.
      `,
      };
    }

    // Application Under Review
    if (status === "pending") {
      return {
        question_statement: `
        <span style="font-weight: 600;">Application Under Review:</span> Your application is currently being reviewed. Please wait while we evaluate your information. You’ll be notified once a decision has been made.
      `,
      };
    }

    // Application Approved, Processing Fee Due
    if (status === "approved" && initialPaymentStatus !== "paid") {
      return {
        question_statement: `
        <span style="font-weight: 600;">Approved:</span> Congratulations! Your application has been approved.
        <br />
        <span style="font-weight: 600;">Next Step:</span> Please pay your processing fee to continue.
      `,
      };
    }

    // Default fallback: Draft
    return {
      question_statement: `
      <span style="font-weight: 600;"> Important:</span> Your application is currently in <span style="font-weight: 600;">draft form</span> and has not been submitted yet. 
      <br />
      You can continue editing and complete it anytime from where you left off.
    `,
    };
  }

  const getAddonList = async () => {
    const result = await list_addon_api();
    if (result.code === 200) {
      setAddonFormList(result?.forms);
    } else {
      console.error(result.message);
    }
  };

  const handleDashboard = (e) => {
    e.preventDefault();
    navigate("/dashboard");
  };

  useEffect(() => {
    if (!localStorage.getItem("code-verified")) {
      navigate("/login", { replace: true });
    } else {
      handleFetchDetail();
      getAddonList();
    }
  }, []);

  if (initialLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
        }}
      >
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <>
      <CustomConfirmation
        open={logoutDialogOpen}
        setOpen={setLogoutDialogOpen}
        title={
          "Are you sure you want to delete this draft? Your entire filled form and all entered data will be permanently lost."
        }
        handleAgree={handleLogout}
      />

      <div className="header-container">
        <DashboardHeader />
      </div>

      <div
        className="container-fluid mt-3"
        style={{
          display: "flex",
          justifyContent: "center",
          paddingBottom: "24px",
        }}
      >
        <div style={{ width: "100%", maxWidth: "900px" }}>
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <IconButton onClick={handleDashboard}>
                <ArrowBackIcon sx={{ fontSize: 20, color: "#15978a" }} />
              </IconButton>
            </div>
            <div>
              <h2 className="primary-color mb-0">Application</h2>
            </div>
            <div style={{ width: "40px" }}></div>
          </div>
          <Card
            sx={{
              mt: 2,
              mb: 2,
              backgroundColor: "#fff !important",
              borderLeft: "15px solid #15978a",
              boxShadow: 1,
            }}
          >
            <CardContent
              className="p-3"
              sx={{ display: "flex", alignItems: "flex-start" }}
            >
              {getIcon(
                findData?.form_status,
                findData?.initial_payment_status,
                findData?.investment_payment_status
              )}
              <div
                style={{ color: "#333" }}
                dangerouslySetInnerHTML={{
                  __html: getQuestionStatement(
                    findData?.form_status,
                    findData?.initial_payment_status,
                    findData?.investment_payment_status
                  ).question_statement,
                }}
              />
            </CardContent>
          </Card>
          <div
            className="d-flex justify-content-between align-items-center mt-3"
            style={{ marginBottom: "10px" }}
          >
            <h3 className="primary-color mb-0">Application Summary</h3>
          </div>
          <div className="draft-card">
            {(findData?.investment_payment_status === "unpaid" ||
              findData?.form_status === "pending") && (
              <div style={{ paddingBottom: "4px", marginBottom: "4px" }}>
                <div className="d-flex flex-wrap w-100">
                  <div className="w-100">
                    {findData?.investment_payment_status === "unpaid" ? (
                      <div
                        className="payment-failed-msg"
                        style={{ marginBottom: 0 }}
                      >
                        Your previous payment was unsuccessful.
                      </div>
                    ) : findData?.form_status === "pending" ? (
                      <div
                        className="application-pending-msg"
                        style={{ marginBottom: 0 }}
                      >
                        Your application has been submitted successfully and is
                        now under review. You can track the progress of your
                        application on your dashboard. We’ll notify you via
                        email as soon as there is an update or if any further
                        action is required from your side.
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )}

            <Grid container spacing={2} alignItems="center">
              {/* Column 1: Case Number & Status */}
              <Grid item md={4} sm={12} xs={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <div style={{ flexShrink: 0 }}>
                    <p className="app-label mb-0">Case Number</p>
                    <p className="case-number mb-0">
                      {findData?.case_number || "N/A"}
                    </p>
                  </div>
                  <div className="custom-divider"></div>
                  <div style={{ flexGrow: 1 }}>
                    {findData?.form_status === "rejected" ? (
                      <div className="status-wrapper">
                        <div className="status-badge status-rejected">
                          <BlockIcon sx={{ fontSize: 18 }} />
                          Rejected
                        </div>
                        {findData?.note && (
                          <Tooltip title="View Rejection Reason" arrow>
                            <VisibilityIcon
                              sx={{
                                cursor: "pointer",
                                marginLeft: "8px",
                                fontSize: "18px",
                                color: "#15978a",
                              }}
                              onClick={() => handleReasonDialogOpen()}
                            />
                          </Tooltip>
                        )}
                      </div>
                    ) : findData?.form_status === "info_required" ? (
                      <div className="status-wrapper">
                        <div className="status-badge status-info">
                          <InfoIcon sx={{ fontSize: 18 }} />
                          Info Required
                        </div>
                        {findData?.note && (
                          <Tooltip title="View Rejection Reason" arrow>
                            <VisibilityIcon
                              sx={{
                                cursor: "pointer",
                                marginLeft: "8px",
                                fontSize: "18px",
                                color: "#15978a",
                              }}
                              onClick={() => handleReasonDialogOpen()}
                            />
                          </Tooltip>
                        )}
                      </div>
                    ) : findData?.investment_payment_status === "paid" ? (
                      <div className="status-badge status-paid">
                        <CheckCircleIcon sx={{ fontSize: 18 }} />
                        Investment Payment Paid
                      </div>
                    ) : findData?.investment_payment_status === "processing" ? (
                      <div className="status-badge status-processing">
                        <CheckCircleIcon sx={{ fontSize: 18 }} />
                        Your Investment Payment In Processing
                      </div>
                    ) : findData?.form_status === "approved" ? (
                      <div className="status-badge status-approved">
                        <CheckCircleIcon sx={{ fontSize: 18 }} />
                        Approved
                      </div>
                    ) : findData?.form_status === "pending" ? (
                      <div className="status-badge status-review">
                        <HourglassEmptyIcon sx={{ fontSize: 18 }} />
                        In Review
                      </div>
                    ) : findData?.form_status === "fee_pending" ? (
                      <div className="status-badge status-review">
                        <HourglassEmptyIcon sx={{ fontSize: 18 }} />
                        Fee Pending
                      </div>
                    ) : findData?.form_status === "incomplete" ? (
                      <div className="status-badge status-processing">
                        <PendingActionsRoundedIcon sx={{ fontSize: 18 }} />
                        Incomplete
                      </div>
                    ) : (
                      <div className="footer-text">
                        {show_proper_words(findData?.form_status)}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>

              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  display: { md: "block", xs: "none" },
                  borderColor: "#e2e8f0",
                  height: "60px",
                  alignSelf: "center",
                }}
              />

              {/* Column 2: Dates & Notice */}
              <Grid item md={4} sm={12} xs={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    gap: 0.5,
                  }}
                >
                  <div style={{ display: "flex", gap: "16px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="info-label">LAST UPDATED</div>
                      <div className="info-value">
                        {moment(findData?.updatedAt).format("MM-DD-YYYY")}
                      </div>
                    </div>
                    {findData?.submitted_date && (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="info-label">SUBMISSION DATE</div>
                        <div className="info-value">
                          {findData?.submitted_date
                            ? moment(findData?.submitted_date).format(
                                "MM-DD-YYYY"
                              )
                            : "N/A"}
                        </div>
                      </div>
                    )}
                  </div>

                  {findData?.form_status === "fee_pending" &&
                    findData?.investment_payment_status !== "paid" &&
                    findData?.investment_payment_status !== "processing" && (
                      <div className="notice-box normal-notice mt-1">
                        <>
                          <span className="me-1 fw-600">Final Step:</span> Pay
                          the investment fee.
                        </>
                      </div>
                    )}
                </div>
              </Grid>

              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  display: { md: "block", xs: "none" },
                  borderColor: "#e2e8f0",
                  height: "60px",
                  alignSelf: "center",
                }}
              />

              {/* Column 3: Actions */}
              <Grid
                item
                md={4}
                sm={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: { md: "flex-end", xs: "flex-start" },
                  alignItems: "center",
                  mt: { md: 0, xs: 2 },
                  ml: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    width: "100%",
                  }}
                >
                  {findData?.form_status === "pending" ? (
                    findData?.initial_payment_status === "processing" || findData?.investment_payment_status === "processing" ? (
                      <span className="notice-box review-notice">
                        Fee Payment is Under Review
                      </span>
                    ) : (
                      <span className="notice-box review-notice">
                        Application is Under Review
                      </span>
                    )
                  ) : null}
                  {findData?.form_status === "rejected" ? (
                    <span className="notice-box rejected-notice">
                      Application is Rejected
                    </span>
                  ) : null}
             

                  {findData?.initial_payment_status !== "paid" && (
                    findData?.initial_payment_status !== "processing" &&
                    <div className="expire-notice">
                      <span>
                        Expires on:{" "}
                        <span className="fw-600">
                          {moment(findData?.updatedAt)
                            .add(30, "days")
                            .format("MM-DD-YYYY")}
                        </span>
                      </span>
                    </div>
                  )}

                  <div
                    style={{
                      marginLeft: "auto",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    {findData?.form_history &&
                      findData?.form_history.length > 0 && (
                        <Button
                          sx={button_history_styles}
                          onClick={handleHistoryDialogOpen}
                          variant="outlined"
                          startIcon={<HistoryIcon />}
                        >
                          History
                        </Button>
                      )}
                  </div>
                  {findData?.form_status === "info_required" ? (
                    <Button
                      variant="contained"
                      onClick={handleContinue}
                      endIcon={<ArrowForwardIcon />}
                    >
                      Edit Your Form
                    </Button>
                  ) : (
                    ""
                  )}
                  {findData?.investment_payment_status === "paid" ||
                  findData?.investment_payment_status === "processing" ? (
                    ""
                  ) : findData?.investment_payment_status === "unpaid" ? (
                    <Button
                      variant="contained"
                      onClick={() => {
                        navigate(`/payments`);
                      }}
                      endIcon={<ArrowForwardIcon />}
                    >
                      Pay Investment Fee
                    </Button>
                  ) : (
                    <>
                      {findData?.initial_payment_status === "paid" &&
                      (findData?.form_status === "approved" ||
                        findData?.form_status === "fee_pending") &&
                      findData?.investment_payment_status !== "paid" ? (
                        <Button
                          variant="contained"
                          onClick={() => {
                            navigate(`/payments`);
                          }}
                          endIcon={<ArrowForwardIcon />}
                        >
                          Pay Investment Fee
                        </Button>
                      ) : findData?.form_status === "pending" ||
                        findData?.form_status === "rejected" ||
                        findData?.form_status === "info_required" ? (
                        ""
                      ) : (
                        <Button
                          variant="contained"
                          onClick={handleContinue}
                          endIcon={<ArrowForwardIcon />}
                        >
                          Continue
                        </Button>
                      )}
                    </>
                  )}
                  <FileManagement mode="menu" form={findData} />
                </div>
              </Grid>
            </Grid>
          </div>
          {/* Add-on - Hidden*/}
          {/* {findData?.initial_payment_status === "paid" &&
            findData?.investment_payment_status === "paid" && (
              <AddonSummary
                addonList={addonFormList}
                formList={findData}
                handleFetchDetail={async () => {
                  await handleFetchDetail();
                  await getAddonList();
                }}
              />
            )} */}
        </div>
      </div>
      <StatusHistoryDialog
        open={openStatusDialog}
        onClose={handleStatusDialogClose}
        mode={statusDialogMode}
        findData={findData}
        selectedNote={selectedNote}
        openBy={openBy}
        onBackToHistory={handleHistoryDialogOpen}
        onViewDetail={handleReasonDialogOpen}
      />
    </>
  );
}

export default DraftPage;
